import './markup-menu'
import $ from 'jquery'
import svg4everybody from 'svg4everybody'

import custom from './components/custom'
import select2 from './components/select2'
import Tabs from './components/tabs'

global.$ = $
global.jQuery = $

document.addEventListener('DOMContentLoaded', () => {
  svg4everybody()
  select2()
  new Tabs()
  custom()
})

$(window).on('load resize', () => {
  if ($(window).width() < 1200) {
    $('.header__mobile-box').append($('.header__nav'))
    $('.post__author').append($('.post__author-text'))
  } else {
    $('.header__center').append($('.header__nav'))
    $('.post__author-text').insertAfter($('.post__author-head'))
  }
})



// WEBPACK FOOTER //
// app/scripts/index.js